// Copyright (c) Ping. All rights reserved.
import type { PaneSection } from '@features/onboarding/tour/paneGuideTypes';

export const accountSections: PaneSection[] = [
  {
    section: 'profile',
    title: 'Your profile',
    body: 'This is how you show up to everyone else. Change your photo and edit your display name here.',
  },
  {
    section: 'details',
    title: 'Profile details',
    body: 'Add a short bio, your job title, company, and contact details. People you chat with can see these on your profile.',
  },
  {
    section: 'discoverable',
    title: 'Visible in search',
    body: 'Choose whether other people can find you by name when they search. Turn it off to stay hidden.',
  },
  {
    section: 'status',
    title: 'Status',
    body: 'Set a short status message with an emoji that appears on your profile. Change it whenever your day changes.',
  },
  {
    section: 'recovery',
    title: 'Recovery passphrase',
    body: 'Ping has no password. Your recovery passphrase is what gets you back in on a new device, so back it up somewhere safe.',
  },
];
